import { Conversation } from '@monolith/legacy/types/conversation';
import { OriginProperty } from './origin-property';

export interface ConversationProperty {
  id: number;
  recipient: Recipient;
  sender: Sender;
  message: {
    id: number;
    ai_generated_ratio?: number;
  };
  origin: OriginProperty;
}

interface Sender {
  name: string;
  id: number;
  type: string;
}

export interface Recipient {
  name: string;
  id: number;
  type: string;
}

export function createRecipientProperty(recipientEntity): Recipient {
  return {
    name: recipientEntity.name,
    id: recipientEntity.id,
    type: recipientEntity.type,
  };
}

function createSenderProperty(senderEntity): Sender {
  return {
    name: senderEntity.name,
    id: senderEntity.id,
    type: senderEntity.type,
  };
}

export function createConversationProperty(message: Conversation, aiGeneratedRatio: number = 0): ConversationProperty {
  const result: ConversationProperty = {
    id: message.id,
    recipient: createRecipientProperty(message.recipient.entity),
    sender: createSenderProperty(message.sender.entity),
    message: {
      id: message.last_message?.id,
      ai_generated_ratio: Math.round(aiGeneratedRatio * 100) / 100, // Ensure two-decimal precision
    },
    origin: message.last_message?.origin,
  };

  return result;
}
